import { GetStaticProps } from 'next';

import BluebonnetLandingContent from '../../components/_organisms/BluebonnetLandingContent';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../../providers/tolgee';

interface Props {
  isAuthenticated: boolean;
}

const BluebonnetLandingPage = ({ isAuthenticated }: Props) => {
  return (
    <LandingPageLayout
      title="The Curipod + Texas Bluebonnet Curriculum"
      subTitle="Bluebonnet brings structure and rigor to K-5 Texas RLA classrooms. Curipod brings the dialogue, the curiosity, and the deep engagement with the Bluebonnet curriculum. A powerful complement to the resources your teachers are already using."
      disableHeadline={true}
    >
      <BluebonnetLandingContent variant="default" isAuthenticated={isAuthenticated} />
    </LandingPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default BluebonnetLandingPage;
